/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateManpowerSettingCommand } from '../../models/update-manpower-setting-command';
import { UpdateManpowerSettingCommandResult } from '../../models/update-manpower-setting-command-result';

export interface ApiManpowerSettingUpdateManpowerSettingPut$Params {
  
    /**
     * The command containing the updated details for the manpower setting.
     */
    body?: UpdateManpowerSettingCommand
}

export function apiManpowerSettingUpdateManpowerSettingPut(http: HttpClient, rootUrl: string, params?: ApiManpowerSettingUpdateManpowerSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateManpowerSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiManpowerSettingUpdateManpowerSettingPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateManpowerSettingCommandResult>;
    })
  );
}

apiManpowerSettingUpdateManpowerSettingPut.PATH = '/api/ManpowerSetting/UpdateManpowerSetting';
